function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * AAA IDP Footer component
 * 
 */
import * as React from 'react';
import ErrorValidation from '../../../components/error-validation/ErrorValidation';
import ErrorApi from '../../../components/error-api/ErrorApi';
import OrderExpirationModal from '../../../components/order-expiration-modal/OrderExpirationModal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Redirect } from 'react-router-dom';
import { deleteAll, validate, acceptTerms, licenceDeliveryAddressCountryReset, deliveryMethod, deliveryPickUpStore, deliveryPickupPerson, consentFormError } from '../../../actions/';
import { connect } from 'react-redux';
import { countErrors, Fn } from '../../../functions/Functions';
import { API, OPTIONS, POSTAGE } from '../../../data/Data';
import { portalFetch } from '../../../utils/portalFetch';
import './Footer.scss';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export class Footer extends React.Component {
  constructor(props) {
    super(props);
    /**
     * handleKeydown
     */
    _defineProperty(this, "handleKeydown", e => {
      // $FlowFixMe
      const {
        key
      } = e;
      const {
        focus
      } = this.state;
      if (focus && (key === ' ' || key === 'Enter')) {
        switch (focus) {
          case 'cancel':
            this.cancel();
            break;
          case 'confirm':
            this.cancel();
            break;
          case 'continue':
            this.continue();
            break;
          case 'next':
            this.next();
            break;
          default:
          // no op
        }
      }
    });
    /**
     * onFocus
     */
    _defineProperty(this, "onFocus", focus => {
      this.setState({
        focus
      });
    });
    /**
     * onBlur
     */
    _defineProperty(this, "onBlur", () => {
      this.setState({
        focus: ''
      });
    });
    /**
     * are all fields valid?
     */
    _defineProperty(this, "allValid", () => {
      const errors = countErrors(this.props);
      let sanityCheckErrors = errors;
      if (this.props.addresses?.licenceDelivery && this.props.addresses?.licenceDelivery === 'International' && this.props.addresses?.licenceDeliveryAddressCountry?.value) {
        let countryValue = this.props.addresses?.licenceDeliveryAddressCountry?.value;
        // We cant have this it says "select" but its allready prefilled.
        if (countryValue === 'AU') {
          this.props.internationalShippingError();
          sanityCheckErrors = sanityCheckErrors + 1;
        }
      }

      /**
       * Somehow validation is not working for checkboxes.
       */
      if (this.props.terms) {
        if (this.props.terms.value === false) {
          sanityCheckErrors = sanityCheckErrors + 1;
          this.props.setTerms('terms');
        }
      }

      /**
       * Validate delivery method and pick up store
       */
      if (this.props.deliveryMethod && this.props.deliveryMethod.value === '') {
        sanityCheckErrors = sanityCheckErrors + 1;
        this.props.setDeliveryMethod();
      }
      if (this.props.deliveryMethod && this.props.deliveryMethod.value === 'PickUpInStore' && this.props.deliveryPickUpStore && this.props.deliveryPickUpStore.value === 0) {
        sanityCheckErrors = sanityCheckErrors + 1;
        this.props.setDeliveryPickUpStore();
      }

      /**
       * Validate pickup person and consent form
       */
      if (this.props.deliveryMethod && this.props.deliveryMethod.value === 'PickUpInStore' && this.props.deliveryPickupPerson && !this.props.deliveryPickupPerson.value) {
        sanityCheckErrors = sanityCheckErrors + 1;
        this.props.setDeliveryPickupPerson();
      }
      if (this.props.deliveryPickupPerson && this.props.deliveryPickupPerson.value === 'other' && this.props.consentForm && !this.props.consentForm.value) {
        sanityCheckErrors = sanityCheckErrors + 1;
        this.props.setConsentFormError();
      }
      if (sanityCheckErrors === 0) {
        this.submit();
      } else {
        this.setState({
          next: false,
          submitting: false,
          spinner: false
        });
      }
    });
    /**
     * submit
     */
    _defineProperty(this, "submit", () => {
      const {
        application
      } = this.props;
      const data = Fn.formatData(this.props);
      const options = {
        ...OPTIONS,
        method: 'PUT',
        body: JSON.stringify(data)
      };
      //console.log(data);return;
      const url = `${API}/${application.id}`;
      this.setState({
        spinner: true
      });
      portalFetch(url, options).then(response => {
        if (response.status >= 400) {
          this.setState({
            apiError: true,
            spinner: false
          });
          const message = `HTTP status code: ${response.status}`;
          const err = new Error(message);
          response.json().then(result => console.warn(result));
          throw err;
        } else {
          return response.json();
        }
      }).then(result => this.success(result)).catch(err => this.error(err));
    });
    /**
     * success posting to API
     */
    _defineProperty(this, "success", result => {
      const {
        jest
      } = this.props;
      if (result?.data?.order_status && result?.data?.order_status !== 'Pending') {
        this.cancelAndRedirect();
      }

      // handle API validation errors
      if (result.errors || result.message === 'Server Error') {
        this.validationError(result);
      } else {
        if (!jest) {
          window.scrollTo({
            top: 0,
            behavior: 'smooth'
          });
        }
        setTimeout(() => {
          this.setState({
            next: true,
            spinner: false
          });
        }, 1000);
      }
    });
    /**
     * Error
     */
    _defineProperty(this, "error", err => {
      const {
        application,
        bugsnagClient,
        jest
      } = this.props;
      if (jest) return null;
      console.warn(err);
      err.message = `${err.message}; Application id: ${application.id}`;
      bugsnagClient.notify(err);
    });
    /**
     * API validation error(s)
     */
    _defineProperty(this, "validationError", result => {
      this.setState({
        apiError: true,
        apiErrorMessage: result.message,
        spinner: false
      });
      const msg = `API error${result.message ? ` ${result.message}` : ''}${result.errors ? ` Error(s): ${JSON.stringify(result.errors)}` : ''}`;
      const error = new Error(msg);
      this.error(error);
    });
    /**
     * Go to summary?
     */
    _defineProperty(this, "next", () => {
      this.props.validate();
      this.setState({
        submitting: true
      });
    });
    /**
     * cancel application
     */
    _defineProperty(this, "cancel", () => {
      const {
        application,
        deleteAll
      } = this.props;
      const {
        confirmCancel
      } = this.state;
      if (!confirmCancel) {
        this.setState({
          confirmCancel: true
        });
        return;
      }
      deleteAll();
      window.location = application.referrer;
    });
    /**
     * Cancel application and redirect
     */
    _defineProperty(this, "cancelAndRedirect", () => {
      const {
        application
      } = this.props;
      deleteAll();
      window.location = application.referrer;
    });
    /**
     * Continue application / cancel cancelling application
     */
    _defineProperty(this, "continue", () => {
      this.setState({
        confirmCancel: false
      });
    });
    this.state = {
      apiError: false,
      apiErrorMessage: '',
      confirmCancel: false,
      focus: '',
      next: false,
      spinner: false,
      submitting: false
    };
  }
  componentDidMount() {
    // $FlowFixMe
    document.addEventListener('keydown', this.handleKeydown);
  }
  componentWillUnmount() {
    // $FlowFixMe
    document.removeEventListener('keydown', this.handleKeydown);
  }
  componentDidUpdate(prevProps, prevState) {
    if (!prevState.submitting && this.state.submitting) {
      this.allValid();
    }
  }
  render() {
    const {
      apiError,
      confirmCancel,
      next,
      spinner
    } = this.state;
    const errors = countErrors(this.props);
    const disabled = errors > 0 || apiError ? ' disabled' : '';
    if (next) {
      return /*#__PURE__*/_jsx(Redirect, {
        to: "/summary"
      });
    }
    return /*#__PURE__*/_jsxs(React.Fragment, {
      children: [/*#__PURE__*/_jsx(OrderExpirationModal, {}), /*#__PURE__*/_jsx(ErrorValidation, {
        errors: errors
      }), /*#__PURE__*/_jsx(ErrorApi, {
        apiError: apiError
      }), /*#__PURE__*/_jsx("section", {
        className: "Footer",
        children: confirmCancel ? /*#__PURE__*/_jsxs(React.Fragment, {
          children: [/*#__PURE__*/_jsxs("div", {
            className: "confirm-cancel-text",
            children: ["Are you sure you want to ", /*#__PURE__*/_jsx("strong", {
              children: "CANCEL"
            }), " your application?"]
          }), /*#__PURE__*/_jsxs("div", {
            className: "button reverse cancel confirm",
            onClick: this.cancel,
            tabIndex: "0",
            role: "button",
            onFocus: () => this.onFocus('confirm'),
            onBlur: this.onBlur,
            children: [/*#__PURE__*/_jsx(FontAwesomeIcon, {
              icon: "xmark"
            }), "Yes, Cancel"]
          }), /*#__PURE__*/_jsxs("div", {
            className: "button reverse cancel continue",
            onClick: this.continue,
            tabIndex: "0",
            role: "button",
            onFocus: () => this.onFocus('continue'),
            onBlur: this.onBlur,
            children: [/*#__PURE__*/_jsx(FontAwesomeIcon, {
              icon: "rotate-left"
            }), "No, don't cancel"]
          })]
        }) : /*#__PURE__*/_jsxs(React.Fragment, {
          children: [/*#__PURE__*/_jsxs("div", {
            className: 'button reverse cancel',
            onClick: this.cancel,
            tabIndex: "0",
            role: "button",
            onFocus: () => this.onFocus('cancel'),
            onBlur: this.onBlur,
            children: [/*#__PURE__*/_jsx(FontAwesomeIcon, {
              icon: "xmark"
            }), "Cancel application"]
          }), /*#__PURE__*/_jsxs("div", {
            className: `button next${disabled}`,
            onClick: () => this.next(),
            tabIndex: "0",
            role: "button",
            onFocus: () => this.onFocus('next'),
            onBlur: this.onBlur,
            children: [spinner ? /*#__PURE__*/_jsx(FontAwesomeIcon, {
              icon: "spinner",
              spin: true
            }) : /*#__PURE__*/_jsx(FontAwesomeIcon, {
              icon: "chevron-right"
            }), "Next: Summary"]
          })]
        })
      })]
    });
  }
}
_defineProperty(Footer, "defaultProps", {
  application: {
    referrer: 'http://localhost:3000/'
  },
  bugsnagClient: {
    notify: () => null
  },
  club: {
    autoClub: {
      error: false
    }
  },
  contacts: {
    contactNumber: {
      error: false
    }
  },
  deliveryMethod: {
    error: false
  },
  deliveryPickUpStore: {
    error: false
  },
  deliveryPickupPerson: {
    error: false,
    value: ''
  },
  consentForm: {
    error: false,
    value: ''
  },
  dateOfBirth: {
    error: false
  },
  dateOfTravel: {
    error: false
  },
  email: {
    error: false
  },
  confirmEmail: {
    error: false
  },
  jest: false,
  licenceClass: {
    error: false
  },
  licenceExpiry: {
    error: false
  },
  licenceNumber: {
    error: false
  },
  names: {
    fullName: {
      error: false
    }
  },
  placeOfBirth: {
    error: false
  },
  postage: {
    ...POSTAGE[0]
  },
  stateOfIssue: {
    error: false
  },
  terms: {
    error: false
  }
});
const mapStateToProps = ({
  addresses,
  application,
  club,
  confirmEmail,
  contacts,
  cookies,
  dateOfBirth,
  dateOfTravel,
  deliveryMethod,
  deliveryPickUpStore,
  deliveryPickupPerson,
  consentForm,
  email,
  images,
  marketingConsent,
  names,
  licenceClass,
  licenceExpiry,
  licenceNumber,
  placeOfBirth,
  postage,
  stateOfIssue,
  transaction,
  terms
}) => {
  return {
    addresses,
    application,
    club,
    confirmEmail,
    contacts,
    cookies,
    dateOfBirth,
    dateOfTravel,
    deliveryMethod,
    deliveryPickUpStore,
    deliveryPickupPerson,
    consentForm,
    email,
    images,
    marketingConsent,
    names,
    licenceClass,
    licenceExpiry,
    licenceNumber,
    placeOfBirth,
    postage,
    stateOfIssue,
    transaction,
    terms
  };
};
const mapDispatchToProps = dispatch => {
  return {
    deleteAll: () => {
      dispatch(deleteAll());
    },
    validate: () => {
      dispatch(validate());
    },
    setTerms: fieldName => {
      if (fieldName === 'terms') {
        dispatch(acceptTerms(false));
      }
    },
    setDeliveryMethod: () => {
      dispatch(deliveryMethod(''));
    },
    setDeliveryPickUpStore: () => {
      dispatch(deliveryPickUpStore(0));
    },
    setDeliveryPickupPerson: () => {
      dispatch(deliveryPickupPerson(''));
    },
    setConsentFormError: () => {
      dispatch(consentFormError(true, 'Please upload the completed consent form.'));
    },
    internationalShippingError: () => {
      dispatch(licenceDeliveryAddressCountryReset());
    }
  };
};
const VisibleFooter = connect(mapStateToProps, mapDispatchToProps)(Footer);
export default VisibleFooter;